import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { enforceGithubSessionAllowlist } from '../../lib/enforceGithubSession';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing sign in…');

  useEffect(() => {
    let cancelled = false;

    const finish = async () => {
      const { data, error } = await supabase.auth.getSession();
      if (cancelled) return;

      if (error) {
        setMessage(error.message);
        window.setTimeout(() => navigate('/login', { replace: true }), 2500);
        return;
      }

      const allowed = await enforceGithubSessionAllowlist(data.session, { toastOnReject: true });
      if (cancelled) return;

      if (allowed) {
        navigate('/', { replace: true });
        return;
      }

      if (data.session) {
        setMessage('GitHub account not authorized — redirecting…');
      } else {
        setMessage('No session found — redirecting to login…');
      }
      window.setTimeout(() => navigate('/login', { replace: true }), 1500);
    };

    void finish();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-3 text-gray-600 dark:text-gray-400">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
